
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/current-bids",
      function () {
        return require("private-next-pages/user/current-bids/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/current-bids"])
      });
    }
  